

// Importar React y el hook useState desde la biblioteca 'react'
import React, { useState } from 'react';
import {  useNavigate } from "react-router-dom";
// Definición del componente funcional LicenciaForm
const LicenciaForm = ({ submitCallback }) => {
  // Definir estados locales para cada campo del formulario
  const [nombre, setNombre] = useState('');
  const [primerApellido, setPrimerApellido] = useState('');
  const [segundoApellido, setSegundoApellido] = useState('');
  const [licencia, setLicencia] = useState('');
  const [plastico, setPlastico] = useState('');
  const [telefono, setTelefono] = useState('');
  const [processing] = useState(false); 
  const [error, ] = useState(null); 
  const navigate = useNavigate() 

  // Función para manejar el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    const url = `/busqueda-licencias?nombre=${nombre}&primerApellido=${primerApellido}&segundoApellido=${segundoApellido}&licencia=${licencia}&plastico=${plastico}&telefono=${telefono}`
    navigate(url)
  }

  // Renderizar el formulario
  return (
    <form className="questionnaire" onSubmit={handleSubmit}>
      {/* Renderizar los campos del formulario */}
      <div className="question">
        <label>
          Nombre:
          <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Primer Apellido:
          <input type="text" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Segundo Apellido:
          <input type="text" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Licencia:
          <input type="text" value={licencia} onChange={(e) => setLicencia(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Plastico:
          <input type="text" value={plastico} onChange={(e) => setPlastico(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Teléfono:
          <input type="text" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
        </label>
      </div>
       {/* Botón de envío del formulario */}
       <button className='button2' type="submit" disabled={processing}>
        {processing ? 'Buscando...' : 'Buscar'}
      </button>


      {/* Mostrar mensaje de error si existe */}
      {error && <div className="error-message">{error}</div>}
    </form>

  );
};

// Exportar el componente LicenciaForm
export default LicenciaForm;
